import { createFileRoute, redirect } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";

export const Route = createFileRoute("/app/$customer/requests/$id")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/c/$customerSlug/requests/$id",
      params: { customerSlug: params.customer, id: params.id },
      replace: true,
    });
  },
});
